<template>
  <div :class="['col-md-8 col-lg-8 offset-md-2 offset-lg-2 page eh-ds', { 'page--mobile': isMobile() }]">
    <div class="page-help-corner">
      <help-icon help-id="devices" title="Help for Devices" />
    </div>
    <div class="device__list">
      <h1 :class="['list__header mt-md-0 mt-0', { 'list__header--mobile': isMobile() }]">DEVICE LIST</h1>

      <template v-if="!isMobile()">
        <div class="gridarea">
          <div class="container">
            <div class="columntop">
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-col">
                <span id="col1" class="coltext">Source</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                <span id="col2" class="coltext">Type</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-5 top-col">
                <span id="col3" class="coltext">Serial Number</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-col">
                <span id="col4" class="coltext">Extension</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                <span id="col5" class="coltext">Gateway</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                <span id="col8" class="coltext"></span>
              </div>
            </div>
            <div v-if="deviceLoadError" class="columnrow columnrow--empty">
              {{ deviceLoadError }} This is not an empty list — try again shortly.
            </div>
            <div v-else-if="currentMeters.length == 0" class="columnrow columnrow--empty">
              <h2 class="no__devices">NO DEVICES REGISTERED</h2>
            </div>

            <div v-else v-for="meter in currentMeters" class="columnrow" :key="meter.MeterID._text">
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-row-device">
                <span id="meterSource" class="coltext">Fora</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row-device">
                <span id="meterType" class="coltext">{{
                  meter.MeterName._cdata + ' (' + meter.MeterType._text + ')'
                }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-5 top-row-device">
                <span id="meterId" class="coltext">{{
                  meter.MeterID._text
                }}</span>
                <small v-if="meter.syncLabel" :class="['sync-status', 'sync-status--' + meter.syncStatus]">{{ meter.syncLabel }}</small>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-row-device">
                <span id="meterEx" class="coltext">{{
                  meter.MeterExID._text
                }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row-device">
                <span id="meterGateway" class="coltext">{{
                  meter.GatewayID._text
                }}</span>
              </div>
              <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row-device">
                <button class="meter__delete"
                  @click="deleteMeter(meter.MeterType._text, meter.MeterID._text, meter.MeterExID._text)">{{ meter.removed ? 'Retry removal' : 'Remove Device' }}</button>
              </div>
            </div>
          </div>
          <div class="collapse" id="cptInfo">
            <div class="card card-body">
              <cpt-desc :currentInfo="focusedCurCpt" :historicalInfo="focusedHistCpt" :measurements="measurements"/>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <p v-if="deviceLoadError" class="no__devices no__devices--mobile">{{ deviceLoadError }}</p>
        <p v-else-if="currentMeters.length === 0" class="no__devices no__devices--mobile">No devices registered</p>
        <div v-else class="table-container">
          <div class="accordion">
            <div
              v-for="(meter, index) in currentMeters"
              :key="meter.MeterID._text"
              :id="'device' + index"
              @click="showDevice(index)"
              class="accordion-item"
            >
              <button type="button" class="accordion-button">
                {{ meter.MeterName._cdata }} ({{ meter.MeterType._text }})
              </button>
              <div class="accordion-content" @click.stop>
                <p><b>Source: </b>Fora</p>
                <p><b>Type: </b>{{ meter.MeterName._cdata }} ({{ meter.MeterType._text }})</p>
                <p><b>Serial Number: </b>{{ meter.MeterID._text }}</p>
                <p v-if="meter.syncLabel"><b>Fora: </b>{{ meter.syncLabel }}</p>
                <p><b>Extension: </b>{{ meter.MeterExID._text }}</p>
                <p><b>Gateway: </b>{{ meter.GatewayID._text }}</p>
                <button
                  type="button"
                  class="meter__delete meter__delete--mobile"
                  @click="deleteMeter(meter.MeterType._text, meter.MeterID._text, meter.MeterExID._text)"
                >
                  {{ meter.removed ? 'Retry removal' : 'Remove Device' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div class="form" ref="formContainer">
      <form @submit.prevent="handleSubmit()" id="form_device">
        <h1 :class="['device__header mt-md-0 mt-0', { 'device__header--mobile': isMobile() }]">ADD A DEVICE</h1>

        <template v-if="!isMobile()">
          <div class="row justify-content-center">
            <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
              <label for="deviceSource" class="device__label">Device Source: </label>
              <select id="deviceSource" v-model="form.deviceSource" class="form-control col-md-6">
                <option v-for="(device, index) in deviceSources" :key="index" :value="device">{{ device }}</option>
              </select>
            </div>

            <template v-if="form.deviceSource != 'N/A'">
              <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
                <label for="deviceType" class="device__label">Device Type: </label>
                <select id="deviceType" v-model="form.deviceType" class="form-control col-md-6">
                  <option v-for="(value, key) in deviceTypes" :key="key" :value="value">{{ key }}</option>
                </select>
              </div>

              <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
                <label for="deviceId" class="device__label">Serial Number: </label>
                <input id="deviceId" type="text" v-model="form.deviceId" class="form-control col-md-6"
                  @change="validateDeviceId(form.deviceId)">
                <form-error :errors="formErrors.deviceId" />
              </div>

              <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
                <label for="deviceExId" class="device__label">Device Extension: </label>
                <select id="deviceExId" v-model="form.deviceExId" class="form-control col-md-6">
                  <option v-for="x in 4" :key="x" :value="x">{{ x }}</option>
                </select>
              </div>

              <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
                <label for="gatewayId" class="device__label">Gateway Id: </label>
                <input id="gatewayId" type="text" v-model="form.gatewayId" class="form-control col-md-6">
              </div>
            </template>
          </div>
          <div v-if="form.deviceSource != 'N/A'" class="row justify-content-center">
            <div class="col-md-3 col-lg-10 col-sm-6 col-6 form-group">
              <label for="deviceICD" class="device__label">Diagnosis: </label>
              <AutoComplete class="col-md-6 form-control" v-model="form.deviceICD" :suggestions="apiDiags" @complete="apiLookup" :dropdown="true" placeholder="Select an already added diagnosis by clicking on the arrow or begin typing for a new diagnosis" forceSelection>
              </AutoComplete>
            </div>
          </div>
          <div class="btn-container">
            <button class="btn btn-primary float-end devices add" type="button" @click="registerDevice"> ADD </button>
          </div>
        </template>

        <template v-else>
          <div class="mobile-form-group">
            <label for="deviceSourceMobile" class="device__label device__label--mobile">Device Source:</label>
            <select id="deviceSourceMobile" v-model="form.deviceSource" class="mobile-input">
              <option v-for="(device, index) in deviceSources" :key="index" :value="device">{{ device }}</option>
            </select>
          </div>

          <template v-if="form.deviceSource != 'N/A'">
            <div class="mobile-form-group">
              <label for="deviceTypeMobile" class="device__label device__label--mobile">Device Type:</label>
              <select id="deviceTypeMobile" v-model="form.deviceType" class="mobile-input">
                <option v-for="(value, key) in deviceTypes" :key="key" :value="value">{{ key }}</option>
              </select>
            </div>

            <div class="mobile-form-group">
              <label for="deviceIdMobile" class="device__label device__label--mobile">Serial Number:</label>
              <input
                id="deviceIdMobile"
                type="text"
                v-model="form.deviceId"
                class="mobile-input"
                @change="validateDeviceId(form.deviceId)"
              >
              <form-error :errors="formErrors.deviceId" />
            </div>

            <div class="mobile-form-group">
              <label for="deviceExIdMobile" class="device__label device__label--mobile">Device Extension:</label>
              <select id="deviceExIdMobile" v-model="form.deviceExId" class="mobile-input">
                <option v-for="x in 4" :key="x" :value="x">{{ x }}</option>
              </select>
            </div>

            <div class="mobile-form-group">
              <label for="gatewayIdMobile" class="device__label device__label--mobile">Gateway Id:</label>
              <input id="gatewayIdMobile" type="text" v-model="form.gatewayId" class="mobile-input">
            </div>

            <div class="mobile-form-group">
              <label for="deviceICDMobile" class="device__label device__label--mobile">Diagnosis:</label>
              <AutoComplete
                id="deviceICDMobile"
                class="mobile-autocomplete"
                v-model="form.deviceICD"
                :suggestions="apiDiags"
                @complete="apiLookup"
                :dropdown="true"
                placeholder="Select diagnosis or type to search"
                forceSelection
              />
            </div>
          </template>

          <div class="btn-container btn-container--mobile">
            <button class="mobile-add-btn" type="button" @click="registerDevice">Add Device</button>
          </div>
        </template>
      </form>
    </div>
  </div>
</template>

<script>
import { CURR_API, OTHER_API } from '@/constants/apis'
import { listPatientDevices, listDeviceModels } from '@/api2/devices'
import { meterRowsFromDevices } from '@/utils/meterRows'
import { OWED_REMOVAL } from '@/api2/deviceBridge'
import FormError from "@/components/includes/form/FormError.vue"
import VALIDATION_ERRORS from '@/data/validationErrors';
import axios from 'axios'
import { mapGetters } from 'vuex';
import CptDesc from '../private-layouts/CptDesc.vue'
import {
  getFormattedMeters
} from "@/data/getters";
import { xml2js } from 'xml-js'
import { h } from 'vue';
import { PRIVILEGES } from '@/constants/privileges';
import { assertPrivilegeOrAlert } from '@/utils/privilegeGate';
import HelpIcon from '@/components/help/HelpIcon.vue';
// import { getStates, getPhoneTypes } from '@/data/getters.js';
export default {
  name: "user-devices",
  components: {
    'form-error': FormError,
    'cpt-desc': CptDesc,
    HelpIcon,
  },
  props: ['restricted'],
  data() {
    return {
      allDiags: null,
      apiDiags: null,
      currentMeters: [],
      deviceLoadError: '',
      deviceSources: ['N/A', 'Fora'],
      // Display name -> Fora model code, read from the server's catalogue
      // (GET /device-models). Main hard-coded these eight here and again in
      // keyon; the catalogue is the one list now.
      deviceTypes: {},
      form: {
        deviceSource: 'N/A',
        deviceType: '',
        deviceId: '',
        deviceExId: '',
        gatewayId: '',
        deviceICD: ''
      },
      regCptCost: {
        '99453': 0,
        '99454': 0,
        '99457': 0,
        '99458': 0,
        '99091': 0
      },
      nebCptCost: {
        '98975': 19.38,
        '98976': 55.72,
        '98980': 50.18,
        '98981': 40.84
      },
      attachedCpts: {},
      cptList: {},
      formErrors: {},
      focusedCurCpt: {},
      focusedHistCpt: {},
      measurements: []
    }
  },
  computed: {
    ...mapGetters('login', {
      allData: 'getAllData'
    }),
  },
  created() {
    // initialize errors
    for (let key in this.form) {
      // this.$set(this.formErrors, key, []);
      this.formErrors[key] = []
    }
    // Models first: a device row names its model by code, and the list shows
    // the model's name.
    this.getDeviceModels().then(() => this.getDevices())
    this.getCpts()
    this.getDiags()
    // console.log(this.meters)
  },
  methods: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    showDevice(index) {
      const entry = document.getElementById(`device${index}`);
      if (entry) {
        entry.classList.toggle('active');
      }
    },
    foraErrorMsg(data) {
      return (data && (data.errorMessage || data.ReMsg)) || 'Please contact system administrator.'
    },
    async apiLookup() {
      if (!this.form.deviceICD.length){
        this.apiDiags = this.allDiags
        return
      }
      let content = {
          action: "Search",
          searchTerm: this.form.deviceICD,
          ICDCode: "",
          ICDReleaseUrl: "",
        };
        await axios
          .post(CURR_API + "/icd_calls.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            if (res.data.result == 0) {
              this.apiDiags = [];
            } else {
              this.apiDiags = res.data.actualResults.map(diag => `${diag.code} - ${diag.description}`);
            }
          });
    },
    async getDiags(){
      let content = {
        Diagnosis: {
          API_Meth: "PopulateDiagGrid",
          patientID: this.allData.patient.externId,
        },
      };

      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.gridhtml) {
            this.allDiags = res.data.data.filter(
              (diag) => diag.diagnosis_type === "Diagnosis"
            ).map(el => el.diagnosis_code);
          } else {
            this.allDiags = null;
          }
        });
    },
    validate() {
      if (this.form.deviceSource == "N/A") {
        this.formErrors.deviceId = []
      } else {
        // Judged afresh on every submit, so a field fixed without leaving it
        // does not keep an old message.
        this.validateDeviceId(String(this.form.deviceId || ''))
        if (String(this.form.deviceId || '').trim() === '') {
          // A Fora meter needs its serial number. Main let this go through
          // and enrolled the patient at Fora under an invented meter (keyon
          // made up a MeterID and billed CPT codes against it), with no
          // device on the chart; the server refuses it (422) and sends Fora
          // nothing it was not given by a person.
          this.formErrors.deviceId = [VALIDATION_ERRORS.DEVICE_ID_REQUIRED]
        }
      }
      for (let key in this.formErrors) {
        if (this.formErrors[key]
          && this.formErrors[key].length > 0) {
          return false;
        }
      }
      return true;
    },
    validateDeviceId(deviceId) {
      this.formErrors.deviceId = []
      if (deviceId.length != 16 && deviceId.length != 0) {
        // this.$set(this.formErrors.deviceId, this.formErrors.deviceId.length, VALIDATION_ERRORS.INVALID_DEVICE_ID)
        this.formErrors.deviceId[this.formErrors.deviceId.length] = VALIDATION_ERRORS.INVALID_DEVICE_ID
      }
    },
    async showCptDesc(meterid, cptCode){
      let content = {
          "PatientCpt": {
              "API_Meth": "GetMeasurements",
              "pid": this.allData.patient.externId,
              "meterid": meterid
          }
      }
      await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
      .then((res) => {
          if (res.data.status === "Success")
            this.measurements = res.data.data
          this.focusedCurCpt = this.attachedCpts.current[meterid][cptCode]
          this.focusedHistCpt = this.attachedCpts.historical[meterid] ? this.attachedCpts.historical[meterid][cptCode] : {}
          this.focusedHistCpt ? this.focusedHistCpt[this.focusedCurCpt.fid] = this.focusedCurCpt : {}
      })
    },
    validCpts(cptList, addedCpts){
      let listClone = {...cptList}
      if (addedCpts){
        addedCpts.forEach(cpt => {
          delete listClone[cpt]
        })
      }
      return listClone
    },
    async getCpts() {
      let content = {
        "PatientCpt": {
          "API_Meth": "GetPatientCpt",
          "pid": this.allData.patient.externId
        }
      }
      await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
        .then((res) => {
          // console.log(res)
          let arr = res.data
          // this.$set(this, 'attachedCpts', arr)
          this['attachedCpts'] = arr
          // console.log(this.attachedCpts)
        })
    },
    async confirmCpt(event, meterid) {
      let selected = event.target.value
      if (!selected)
        return
      let cost = this.nebCptCost[selected] ? this.nebCptCost[selected] : this.regCptCost[selected]
      let content = {
        "PatientCpt": {
          "API_Meth": "AddPatientCpt",
          "pid": this.allData.patient.externId,
          "meterid": meterid,
          "cpt": selected,
          "cost": cost,
          "status": 0,
        }
      }
      let supplyWarning = ""
      if (selected === "99454" || selected === "98976")
        supplyWarning = "\nYou MUST have supplied this device in order to bill for this code, to do so otherwise is insurance fraud."
      if (confirm("Would you like to apply CPT code " + selected + " to this device?" + supplyWarning)) {
        // `AddPatientCpt` is an ENROLMENT — it assigns a code to a device —
        // bridged to POST /patients/{patient}/cpt-meters (MX-06), which opens
        // no billing cycle. A refusal comes back as a non-Success status and is
        // alerted below; anything that throws is caught and named here rather
        // than surfacing as an unhandled rejection with the dropdown left
        // showing the code as though it had been applied.
        try {
          const res = await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
          if (!res.data.status)
            alert("Error: Please contact an administrator")
          else if (res.data.status === "Success")
            this.getCpts()
          else
            alert(res.data.status)
        } catch (error) {
          console.error("AddPatientCpt failed:", error)
          alert(
            "CPT code " + selected + " was NOT applied to this device.\n\n" +
            "The assignment could not be saved. Nothing has been billed."
          )
        }
        event.target.value = ""
      }
    },
    async deleteMeter(metertype, meterid, meterexid) {
      if (!assertPrivilegeOrAlert(
        PRIVILEGES.METER_DEVICE_REMOVE,
        'You do not have permission to remove meter devices.'
      )) {
        return;
      }
      let content = {
        "RemovePatientInfo": {
          "API_Meth": "RemovePatientDevice",
          // Org scopes external_id_relationships lookup for legacy Fora PIDs.
          "accountnumber": "" + (this.allData.patient.externId2 || ""),
          "pid": ("" + this.allData.patient.externId).length == 7 ? "0" + this.allData.patient.externId : "" + this.allData.patient.externId,
          "metertype": metertype,
          "meterid": meterid,
          "meterexid": meterexid
        }
      }
      // A meter already off the chart whose removal Fora refused: this sends
      // the removal again rather than deleting anything.
      const retry = this.currentMeters.some((meter) => meter.removed && meter.MeterID._text === meterid)
      const question = retry
        ? "Would you like to send the removal of the device with the serial number " + meterid + " to Fora again?"
        : "Would you like to delete this device with the serial number " + meterid + "?"
      if (confirm(question)) {
        await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
          .then((res) => {
            if (!res.data.ReMsg) {
              window.location.reload()
            }
            else {
              alert("Error: " + this.foraErrorMsg(res.data))
            }
          }, error => {
            alert("Error: Check the console log")
            console.log(error)
          })
      }

    },
    /**
     * The registered devices for this chart.
     *
     * Was a keyon call that returned a Fora XML document inside `ReMsg`, which
     * this page unpacked with `xml2js` and then read as
     * `meter.MeterID._text` — the shape of an XML parse leaking all the way
     * into the template. `GET /patients/{patient}/devices` answers JSON rows,
     * so the parse is gone; the `_text` wrapper is kept only because the
     * template still reads it, and that is the next thing to remove here.
     */
    async getDevices() {
      const patientId = this.allData?.patient?.externId;

      if (!patientId) {
        this.currentMeters = [];
        return;
      }

      try {
        // The chart's meters and the meters taken off it whose removal Fora
        // has not completed: main's list was Fora's own, so a meter Fora
        // would not remove stayed on this page with Fora's error. Without
        // them a failed removal is invisible — the row is gone from the
        // chart, Fora still holds the meter, and its readings keep coming.
        const page = await listPatientDevices(patientId, { ...OWED_REMOVAL, per_page: 100 });

        // The legacy shape the template reads, from the mapper the CPT page
        // shares: a meter is keyed the same on both pages, so an enrolment made
        // on one is the one the other offers (api2/devices.js).
        const devices = page.items || [];

        this.currentMeters = meterRowsFromDevices(devices, (code) => this.modelName(code)).map((meter, i) => ({
          ...meter,
          syncStatus: (devices[i].vendor_sync && devices[i].vendor_sync.status) || 'not_applicable',
          syncLabel: this.syncLabel(devices[i].vendor_sync),
          // Off the chart, removal still owed to Fora: its button sends
          // the removal again.
          removed: Boolean(devices[i].removed_at),
        }));
      } catch (error) {
        // An empty device list and an unreachable one look the same on screen,
        // so say which happened rather than implying the patient has none.
        this.currentMeters = [];
        this.deviceLoadError = 'The device list could not be loaded.';
        console.error('Could not load devices:', error);
      }
    },

    /** The catalogue's Fora models, as the type picker's name -> code map. */
    async getDeviceModels() {
      try {
        const page = await listDeviceModels({ 'filter[data_source]': 'fora_device', per_page: 100 });
        const types = {};
        (page.items || []).forEach((model) => { types[model.display_name] = model.model_code; });
        this.deviceTypes = types;
      } catch (error) {
        // An empty picker says the list failed rather than that there are no
        // models; registering is refused server-side for an unknown type.
        this.deviceTypes = {};
        console.error('Could not load device models:', error);
      }
    },
    modelName(code) {
      const entry = Object.entries(this.deviceTypes).find(([, value]) => value === code);
      return entry ? entry[0] : '';
    },
    /**
     * Where Fora's half of the registration stands. Main showed Fora's answer
     * once, in an alert; the server now registers on its queue and records it.
     */
    syncLabel(sync) {
      if (!sync || !sync.status || sync.status === 'not_applicable') return '';
      const removal = sync.action === 'unregister';
      if (sync.status === 'pending') {
        return removal ? 'Removal from Fora in progress' : 'Registration with Fora in progress';
      }
      if (sync.status === 'synced') return removal ? 'Removed from Fora' : 'Registered with Fora';
      // A removal Fora refused is not a failed registration: the meter is
      // still Fora's to hold for this patient, and says so.
      return (removal ? 'Removal from Fora failed' : 'Fora registration failed') + (sync.error ? ': ' + sync.error : '');
    },

    async registerDevice() {
      if (!assertPrivilegeOrAlert(
        PRIVILEGES.METER_DEVICE_ADD,
        'You do not have permission to add meter devices.'
      )) {
        return;
      }
      if (!this.validate()) {
        alert('Please correct the errors in the form before submitting.');
        return;
      }
      let loader = this.$loading.show({}, {
        after: () => h('div', {}, 'Registering your device with ' + this.form.deviceSource + '...')
      });

      let patient = this.allData.patient
      if (this.form.deviceSource == "Fora") {
        let content = {
          "AddPatientInfo": {
            "API_Meth": "AddPatientInformation",
            // Org accountnumber for external_id_relationships upsert after Fora success.
            "accountnumber": "" + (patient.externId2 || ""),
            "pid": ("" + patient.externId).length == 7 ? "0" + patient.externId : "" + patient.externId,
            "paccount": ("PACM" + this.allData.user.userName).substring(0, 20),
            "ppassword": 'pAcM' + patient.externId,
            "psaid": "E01",
            "ptz": "T0002",
            "pname": patient.firstName + ' ' + patient.lastName,
            "pbday": "",
            "psex": patient.gender[0] == 'Male' ? '0' : '1',
            "pheight": 159,
            "pweight": 60,
            "ptel1": "",
            "ptel2": "",
            "pemail": patient.email,
            "paddr": "",
            "prace": "",
            "metertype": this.form.deviceType,
            "meterexid": this.form.deviceExId + '',
            "meterid": this.form.deviceId,
            "gatewayid": this.form.gatewayId,
            "icd": this.form.deviceICD
          }
        }
        try {
          await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
          .then(async (res) => {
            if (res.data.ReCode[0] == '00') {
              // The meter is registered to the chart by that one request; the
              // second create main made through pacmny-be is gone. Fora's half
              // runs on the server's queue and the list shows how it ended.
              if (!alert("Device registered. Registration with " + this.form.deviceSource + " is in progress; the device list shows when it completes.")) { window.location.reload() }
            }
            else if (res.data.ReCode[0] == '35') {
              let content2 = {
                "AddPatientInfo": {
                  "API_Meth": "AddPatientDevice",
                  "accountnumber": "" + (patient.externId2 || ""),
                  "pid": ("" + patient.externId).length == 7 ? "0" + patient.externId : "" + patient.externId,
                  "metertype": this.form.deviceType,
                  "meterexid": this.form.deviceExId + '',
                  "meterid": this.form.deviceId,
                  "gatewayid": this.form.gatewayId,
                  "icd": this.form.deviceICD
                }
              }
              await axios.post(CURR_API + "/tswebhook.php", content2, { headers: { 'Content-Type': 'application/json;' } })
                .then((res) => {
                  if (res.data.ResultData) {
                    alert("Error: Please ensure that your device details are correct.")
                  }
                  else if (res.data.ReCode[0] == '00') {
                    if (!alert("Device registered. Registration with " + this.form.deviceSource + " is in progress; the device list shows when it completes.")) { window.location.reload() }
                  }
                  else {
                    alert("Error: " + this.foraErrorMsg(res.data))
                  }
                }, error => {
                  console.log(error)
                  alert("Error: " + this.foraErrorMsg(error.response?.data))
                })
            }
            else {
              alert("Error: " + this.foraErrorMsg(res.data))
            }
          }, error => {
            console.log(error)
            alert("Error: " + this.foraErrorMsg(error.response?.data))
          })
        } finally {
          try { loader.hide() } catch (e) { /* ignore */ }
          loader = null
        }
      }
      else {
        loader.hide()
        loader = null
        alert("Error: Please select a device source.")
      }
    }
  }
}
</script>

<style scoped lang="scss">
.sync-status {
  display: block;
  font-size: 0.75rem;
}

.sync-status--failed {
  color: #b00020;
}

.page {
  margin: 1.5rem auto;
  padding: 2.0rem;
  margin-bottom: 100px;
}

.page-help-corner {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.35rem;
}

.page--mobile {
  margin: 0.75rem auto;
  padding: 1rem;
  margin-bottom: 80px;
}

.row {
  flex-wrap: nowrap;
}

input,
select {
  font-size: 0.8rem;
}

.btn-container {
  margin-top: 1.0rem;

  .btn {
    font-size: 0.8rem;
    margin: 2px;
  }

  padding-bottom: 3rem;
}

.device__header,
.list__header {
  font-size: 2.5rem;
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 1em;
}

.device__header--mobile,
.list__header--mobile {
  font-size: 1.25rem;
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;
  font-weight: 600;
}

.device__label {
  font-size: 0.80rem;
}

.device__label--mobile {
  display: block;
  font-size: 0.9rem;
  margin-bottom: 0.35rem;
  font-weight: 600;
}

.btn-container {
  margin-top: 1.0rem;

  .btn {
    font-size: 0.8rem;
    margin: 2px;
  }

  padding-bottom: 3rem;
}

//   .device__info {
//       display: inherit;
//   }
.container .top-col {
}

.columntop {
  width: 100%;
  max-width: none;
  display: grid;
  grid-template-columns: 0.9fr 1.6fr 2.1fr 0.9fr 1.6fr 1.3fr;
  align-items: center;
}

.columnrow {
  width: 100%;
  max-width: none;
  display: grid;
  grid-template-columns: 0.9fr 1.6fr 2.1fr 0.9fr 1.6fr 1.3fr;
  align-items: center;
}

.device__list .gridarea .container {
  width: 100%;
  max-width: none;
  padding-left: 0;
  padding-right: 0;
}

.device__list .columntop > *,
.device__list .columnrow > * {
  flex: none;
  max-width: none;
  width: auto;
  min-width: 0;
  padding: 0.7rem 0.65rem;
  text-align: left;
}

.columnrow--empty {
  display: block;
  text-align: center;
  padding: 1.35rem 0.75rem;
  border-bottom: 1px solid #d3d7db;
}

.device__list .top-col,
.device__list .top-row-device {
  border-right: 1px solid #d3d7db;
}

.device__list .top-col:last-child,
.device__list .top-row-device:last-child {
  border-right: none;
}

.device__list .columnrow:not(.columnrow--empty) {
  border-bottom: 1px solid #d3d7db;
}

.no__devices {
  margin: 0;
  font-size: 1.05rem;
}

.columnbottom {
  width: 100%;
  display: flex;
  flex-direction: row;
  max-width: 1500px;
  text-align: center;
  justify-content: center;
}

.pagnav a {
  margin-left: 10px;
}

.searchfindarea .container {
  display: flex;
  flex-direction: row;
}

.gridarea {
  width: 100%;
  height: auto;
}

.addPatientBtn {
  font-size: 18px;
  text-align: center;
  width: 220px;
}

.sharePatientBtn {
  font-size: 18px;
  text-align: center;
  width: 220px;
}

#notifyptchkbx {
  margin-right: 30px;
  margin-left: 10px;
}

// .top-row {
//   flex: inherit;
// }
.msboxwrapper {
  display: none;
  position: relative;
  top: -434px;
  width: 56%;
  height: auto;
  margin: 0px auto;
  /* display: flex;*/
  text-align: center;
  border-radius: 9px;
}

.msboxwrapper .container {
  padding: 0px;
}

.mboxtitle {
  text-align: center;
}

.mboxtitle h2 {
  font-size: 17px;
  margin-top: 15px;
}

.msgbox {
  text-align: right;
  border-style: solid;
  border-width: 1px;
  border-color: #d3d7db;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
}

.ptxtarea {
  width: 100%;
  height: 251px;
  border-style: none;
}

.modalbtn {
  font-size: 18px;
  width: 130px;
  height: 42px;
  margin-top: 20px;
  position: relative;
  right: 20px;
  border-radius: 8px;
}

.modalcancelbtn {
  width: 130px;
  height: 42px;
  margin-top: 20px;
  right: 40px;
  margin-right: 35px;
  border-radius: 8px;
}

.notemsglbl {
  width: 100%;
  height: 42px;
  display: none;
}

.notemsglbl.success {
  font-size: 18px;
  text-align: center;
}

#patientExtern,
#patientName {
  cursor: pointer;
  text-decoration: underline;
}

.device__list {
  margin-bottom: 100px;
}

.meter__delete {
  border-radius: 20px;
}

.no__devices {
  text-align: center;
}

.no__devices--mobile {
  font-size: 1rem;
  padding: 1rem 0;
}

.cpt-list {
  display: flex;
  flex-direction: column;
}

.table-container {
  padding: 0;
}

.accordion {
  margin-top: 0;
}

.accordion-item {
  border-bottom: 1px solid #d3d7db;
}

.accordion-button,
button.accordion-button {
  padding: 12px 15px;
  width: 100%;
  text-align: left;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 1rem;
}

.accordion-content {
  display: none;
  padding: 15px;
}

.accordion-item.active .accordion-content {
  display: block;
}

.accordion-content p {
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

.mobile-form-group {
  margin-bottom: 1rem;
}

.mobile-input {
  width: 100%;
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #d3d7db;
  border-radius: 4px;
  box-sizing: border-box;
}

.mobile-autocomplete {
  width: 100%;
}

.mobile-autocomplete :deep(.p-autocomplete-input) {
  width: 100%;
  padding: 10px;
  font-size: 1rem;
}

.btn-container--mobile {
  padding-bottom: 1.5rem;
}

.mobile-add-btn {
  width: 100%;
  padding: 12px;
  font-size: 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.meter__delete--mobile {
  margin-top: 0.75rem;
  width: 100%;
  padding: 10px;
  font-size: 0.9rem;
  border: 1px solid #d3d7db;
  cursor: pointer;
}
</style>